<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja" class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <router-link to="/loja/minha-conta"><span>Minha Conta</span></router-link>
          </li>
          <li class="item-link">
            <span v-if="this.formFilter.tipo=='C'">Pedido de Venda Normal</span>
            <span v-else-if="this.formFilter.tipo=='V'">Pedido de Venda Direta</span>
            <span v-else>Pedido Ativo Imobilizado</span>
          </li>
        </ul>
      </div>
      <div class="main-content-area">
        <div class="row">
          <div class="col-xs-12">
            <h3 class="box-title first">Pesquisar</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <form @submit.prevent="search" action="#" method="get" name="frm-billing">
              <div class="row">
                <div class="col-md-5">
                  <FormHelper
                    :inputVar="formFilter.dataInicial"
                    :form="formFilter"
                    type="picker"
                    validationType="pastDate2"
                    label="Data Inicial"
                    icon="fa-calendar"
                    mask="##/##/####"
                  ></FormHelper>
                </div>
                <div class="col-md-5">
                  <FormHelper
                    :inputVar="formFilter.dataFinal"
                    :form="formFilter"
                    validationType="pastDate2"
                    label="Data Final"
                    icon="fa-calendar"
                    type="picker"
                    mask="##/##/####"
                  ></FormHelper>
                </div>
                <div class="col-md-2 col-only-button">
                  <button aria-label="Pesquisar" class="btn primary-button stretch">
                    <i class="fa fa-search"></i> Pesquisar
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <div class="alert alert-info" role="alert">
                    <i class="fa fa-search"></i> Pedidos de
                    <span v-if="this.formFilter.tipo=='C'">venda normal</span>
                    <span v-else-if="this.formFilter.tipo=='V'">venda direta</span>
                    <span v-else>ativo imobilizado</span>
                    no período de
                    <span v-html="formatDate(dateInitDefault)"></span>
                    até
                    <span v-html="formatDate(dateFinishDefault)"></span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12">
                  <vue-good-table
                    :columns="columns"
                    :rows="registros"
                    :pagination-options="{
                          enabled: true,
                          mode: 'records',
                          perPage: 20,
                          position: 'top',
                          perPageDropdown: [40, 60],
                          dropdownAllowAll: true,
                          nextLabel: 'Próximo',
                          prevLabel: 'Anterior',
                          rowsPerPageLabel: 'Linhas por página',
                          ofLabel: 'de',
                          pageLabel: 'page',
                          allLabel: 'Todos',
                        }"
                    styleClass="vgt-table"
                  >
                    <template slot="table-row" slot-scope="props">
                      <span
                        v-if="props.column.field == 'valor'"
                      >{{formatCurrency(props.formattedRow[props.column.field])}}</span>
                      <router-link
                      v-else-if="props.column.field == 'ID'"
                      v-bind:to="{ name: 'detalhe-pedido', params: { id: props.formattedRow[props.column.field], tipo: $route.params.tipo }}">
                        <div align="center">
                          <i class="fa fa-search"></i>
                        </div>
                      </router-link>
                      <a
                      v-else-if="props.column.field == 'LinkRastreamento' && props.formattedRow[props.column.field] != ''"
                      v-bind:href="props.formattedRow[props.column.field]"
                      target="_blank">
                        <div align="center">
                          <i class="fa fa-truck"></i>
                        </div>
                      </a>
                      <span v-else>{{props.formattedRow[props.column.field]}}</span>
                    </template>
                    <div slot="emptystate">Sem dados para exibição</div>
                  </vue-good-table>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
    import "vue-good-table/dist/vue-good-table.css";

    import { VueGoodTable } from "vue-good-table";
    import FormHelper from "./partials/FormHelper.vue";

    export default {
        name: "MeusPedidos",
        components: {
            VueGoodTable,
            FormHelper
        },
        data() {
            return {
                requiredFieldMessage: "Por favor, preencha o campo acima",
                formFilter: {
                    attemptSubmit: false,
                    dataInicial: new this.formInput(false),
                    dataFinal: new this.formInput(false),
                    tipo: this.$route.params.tipo //query string para classificação do tipo de pedido
                },
                columns: [
                    { label: "Pedido", field: "nrPedido" },
                    { label: "Data", field: "data" },
                    { label: "Prev.Faturamento", field: "PevDataFaturamento" },
                    { label: "Nota Fiscal", field: "nrFiscal" },
                    { label: "Cliente", field: "cliente" },
                    { label: "Situação", field: "situacao" },
                    { label: "Transportadora", field: "transportadora" },
                    { label: "Valor", field: "valor" },
                    { label: "Detalhes", field: "ID" },
                    { label: "Rastreamento", field: "LinkRastreamento" }
                ],
                registros: [],
            };
        },
        mounted() {

            //this.formFilter.dataInicial.value = this.returnDate(180).toISOString();

            this.getDados();

            const self = this;

            $.ajax({
                url: this.$apiUrl + "Session.svc/getsessions",
                dataType: "json",
                type: "GET",
                xhrFields: { withCredentials: true },
                error: () => {
                    swal({
                        title: "É necessário estar logado",
                        icon: "warning"
                    }).then(() => location.href = `${self.$SiteUrl}/login?redirectTo=` + location.href)
                }
            });
        },
        computed: {
            dateInitDefault: function () {
                return (this.formFilter.dataInicial.value = (this.formFilter.dataInicial.value ? this.formFilter.dataInicial.value : this.returnDate(180)));
            },
            dateFinishDefault: function () {
                var dtNow = new Date();
                return (this.formFilter.dataFinal.value = (this.formFilter.dataFinal.value ? this.formFilter.dataFinal.value : dtNow.toISOString()));
            }
        },
        filters: {
            capitalize: function (str) {
                return str.charAt(0).toUpperCase() + str.slice(1);
            }
        },
        methods: {
            search: function () {
                this.formFilter.attemptSubmit = true;
                var d = this.formFilter.dataFinal.value;
                // console.log(d);
                var dt = new Date(d);
                if (dt < new Date())
                    this.getDados();
            },
            formInput: function (required, value) {
                // Define um padrão para estrutura de cada input do formulário
                this.required = required !== undefined ? required : true;
                this.value = value !== undefined ? value : "";

                this.validation = {
                    // Status é o inverso do requerido, pois se o input for obrigatório, ele inicia com o status inválido
                    // Para que o usuário seja barrado em caso de um submit sem dados
                    status: !this.required,
                    message: this.required ? "Por favor, preencha o campo acima" : ""
                };
            },
            requiredValidation(val) {
                // Valida campos obrigatórios e retorna mensagem padrão
                const validation = {
                    status: !!val,
                    message: !val ? this.requiredFieldMessage : ""
                };

                return validation;
            },
            formatDate: function (value) {
                var d = new Date(value);
                var datestring =
                    ("0" + d.getDate()).slice(-2) +
                    "/" +
                    ("0" + (d.getMonth() + 1)).slice(-2) +
                    "/" +
                    d.getFullYear();

                return datestring;
            },
            returnDate: function (time) {
                //função cria data baseado na quantidade de dias a mais ou a menos baseado na data atual
                var dt = new Date();
                var d = new Date(dt.setDate(dt.getDate() - time));
                //formata data para padrao dd/mm/yyyy
                var datestring =
                    ("0" + d.getDate()).slice(-2) +
                    "/" +
                    ("0" + (d.getMonth() + 1)).slice(-2) +
                    "/" +
                    d.getFullYear();
                // return datestring;
                return d.toISOString();
            },
            formatCurrency: function (v) {
                //formada coluna de valores da tabela para moeda
                v = v.toString().replace(',', '.')
                var formato = {
                    minimumFractionDigits: 2,
                    style: "currency",
                    currency: "BRL"
                };
                return parseFloat(v).toLocaleString("pt-BR", formato);
            },
            getDados: function () {
                this.registros = [];

                //dados de exemplo para tabela
                var xhr = new XMLHttpRequest();
                xhr.onreadystatechange = () => {
                    if (xhr.readyState == 4 && xhr.status == 200) {
                        // console.log("sucesso: ");

                        let json = JSON.parse(xhr.responseText);
                        json.forEach((element, index) => {
                            let item = {};
                            item.nrPedido = element.PevCodigoConcat;
                            item.data = element.PevDataPedido;
                            item.nrFiscal = element.SaiCodigo;
                            item.cliente = element.CliRazaoSocial;
                            item.situacao = element.SituacaoPedido;
                            item.PevDataFaturamento = element.PevDataFaturamento;
                            item.transportadora = element.TraTransportadora;
                            item.valor = element.PevTotnf;
                            item.ID = element.PevCodigo;
                            item.LinkRastreamento = element.LinkRastreamento;
                            this.registros.push(item);
                            //// console.log(item);
                        });
                    } else {
                        // console.log("state:", xhr.readyState, " status:", xhr.status);
                    }
                }
                xhr.open("POST", this.$apiUrl + "PedidosVenda.svc/getpedidos");
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.withCredentials = true;
                xhr.send(JSON.stringify({
                    dataInicial: this.formFilter.dataInicial.value,
                    dataFinal: this.formFilter.dataFinal.value,
                    categoriaPedido: this.$route.params.tipo
                }));
            }
        }
    };
</script>